// D2 - one and two prong pleats - imported by calculatePleat.js

export function calculateD2(totalWidths, COM) {
      console.log('calculateD2() start');

      if (COM == true) {
            switch (totalWidths) {
                  case 1:
                        return 49;
                  case 2:
                        return 98;
                  case 3:
                        return 147;
                  case 4:
                        return 196;
                  case 5:
                        return 246;
                  case 6:
                        return 295;
                  case 7:
                        return 344;
                  case 8:
                        return 393;
                  case 9:
                        return 442;
                  case 10:
                        return 491;
                  default:
                        console.log('- totalWidths out of scope');
                        return 0;
            }
      } else if (COM == false) {
            switch (totalWidths) {
                  case 1:
                        return 43;
                  case 2:
                       return 85;
                  case 3:
                      return 128;
                  case 4:
                      return 171;
                  case 5:
                      return 214;
                  case 6:
                      return 256;
                  case 7:
                      return 299;
                  case 8:
                      return 342;
                  case 9:
                      return 384;
                  case 10:
                      return 427;
                  default:
                        console.log('- totalWidths out of scope');
                        return 0;
            }
      } else {
            console.log('- COM is null');
      }
}
